import { IRequireable } from "../requirements/IRequireable";

export class ComponentTemplate implements IRequireable {
	public static readonly $type: string = "ComponentTemplate";
	public readonly $type: string = ComponentTemplate.$type;

	public id?: number;
	public name!: string;
	public canReorderChildren!: boolean;
}
